import { mergeClasses } from '@griffel/react';

import type { ClassNameAndInlineStyles } from '../../../util/styles/fluent9';
import { useDimensions, usePadding } from '../../../util/styles/fluent9';

export interface DividerClassNameProps {
  readonly height?: string;
  readonly padding?: number;
  readonly verticalPadding?: number;
  readonly horizontalPadding?: number;
  readonly paddingTop?: number;
  readonly paddingRight?: number;
  readonly paddingBottom?: number;
  readonly paddingLeft?: number;
}

type UseClassNamesAndInlineStyles = (props: DividerClassNameProps) => ClassNameAndInlineStyles;

export const useClassNameAndInlineStyles: UseClassNamesAndInlineStyles = ({
  height,
  padding,
  verticalPadding,
  horizontalPadding,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
}) => {
  const dimensionStyling = useDimensions({
    height,
    minHeight: height,
  });

  const paddingProps = {
    padding,
    verticalPadding,
    horizontalPadding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
  };
  const paddingStyling = usePadding(paddingProps);

  return {
    className: mergeClasses(paddingStyling.className, dimensionStyling.className),
    inlineStyles: {
      ...paddingStyling.inlineStyles,
      ...dimensionStyling.inlineStyles,
    },
  };
};
